// aws api profiles
import api from '../../aws/api/profiles/json.profile.api.aws';

const getTagCompaniesApi = (tagId) =>
  api().get(`/tags/${tagId}/companies?is_active=true`);

export default getTagCompaniesApi;
